import React, { useEffect, useMemo, useState } from "react";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const ALLOWED  = [1, 2, 3, 5, 7, 9, 13, 15, 16];

const STATUS_OPTIONS = [
  { value: "AL", label: "All" },
  { value: "NE", label: "New" },
  { value: "IP", label: "In Process" },
  { value: "IT", label: "In Process & Transfer" },
  { value: "CT", label: "Close & Transfer" },
  { value: "CL", label: "Closed" },
];

function parseRange(str) {
  const numbers = [];
  if (!str) return numbers;
  str.split(",").forEach(part => {
    part = part.trim();
    const m = /^(\d+)-(\d+)$/.exec(part);
    if (m) {
      const [s, e] = [parseInt(m[1]), parseInt(m[2])];
      if (!isNaN(s) && !isNaN(e) && s <= e) for (let i = s; i <= e; i++) numbers.push(i);
    } else if (/^\d+$/.test(part)) {
      const n = parseInt(part);
      if (!isNaN(n)) numbers.push(n);
    }
  });
  return numbers;
}

export default function PrintComplaints() {
  const localUser = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); }
    catch { return null; }
  }, []);

  const moduleId = parseInt(localUser?.moduleId, 10);
  const deptId   = parseInt(localUser?.deptid,   10);

  const [employees,  setEmployees]  = useState([]);
  const [error,      setError]      = useState("");
  const [generating, setGenerating] = useState(false);

  const [form, setForm] = useState({
    EmployeeID: "",
    Status:     "AL",
    PrintDate:  "",
    PrintRange: "",
  });

  useEffect(() => {
    if (!ALLOWED.includes(moduleId) || !deptId) return;
    fetch(`${API_ROOT}/api/complaints/print-employees?moduleId=${moduleId}&deptId=${deptId}`)
      .then(r => r.json())
      .then(d => setEmployees(d.data || []))
      .catch(() => setError("Failed to load employees."));
  }, [moduleId, deptId]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const onView = async () => {
    setError("");
    setGenerating(true);
    try {
      const res = await fetch(`${API_ROOT}/api/complaints/print-multiple`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          moduleId,
          deptId,
          empId:            form.EmployeeID || null,
          status:           form.Status,
          printDate:        form.PrintDate  || null,
          complaintNumbers: parseRange(form.PrintRange),
        }),
      });
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        setError(d.message || "Failed to generate PDF");
        return;
      }
      const blob = await res.blob();
      window.open(window.URL.createObjectURL(blob), "_blank", "noopener,noreferrer");
    } catch (err) {
      setError(err.message || "Failed to generate PDF");
    } finally {
      setGenerating(false);
    }
  };

  if (!ALLOWED.includes(moduleId)) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">Unauthorized access Or Session Timed out.</div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-3">
      <h3 className="ctitle">Print Complaints</h3>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="col-lg-10">
        <div className="row g-2 align-items-end">

          <div className="col-sm-4">
            <label className="form-label mb-1">Employee</label>
            <select className="form-select" name="EmployeeID" value={form.EmployeeID} onChange={onChange}>
              <option value="">Select Employee</option>
              {employees.map(e => (
                <option key={e.EmployeeID} value={e.EmployeeID}>
                  {e.EmpName} - {e.Designation}
                </option>
              ))}
            </select>
          </div>

          <div className="col-sm-2">
            <label className="form-label mb-1">Status</label>
            <select className="form-select" name="Status" value={form.Status} onChange={onChange}>
              {STATUS_OPTIONS.map(o => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
          </div>

          <div className="col-sm-2">
            <label className="form-label mb-1">Date</label>
            <input className="form-control" type="date" name="PrintDate"
                   value={form.PrintDate} onChange={onChange} />
          </div>

          <div className="col-sm-2">
            <label className="form-label mb-1">Print Range</label>
            <input className="form-control" type="text" name="PrintRange"
                   value={form.PrintRange} onChange={onChange} placeholder="e.g. 1-5,7,10" />
          </div>

          <div className="col-sm-2">
            <button className="btn btn-primary w-100" onClick={onView} disabled={generating}>
              {generating ? "Generating…" : "View"}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
